<template>
    <div name="medicine-filter-notice" :class="['notice', { 'notice-active': isFiltered }]" role="status">
        <svg class="icon" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <circle cx="9" cy="9" r="7.25" stroke="currentColor" stroke-width="1.5"/>
            <path d="M9 8.2v4.3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
            <circle cx="9" cy="5.6" r="0.95" fill="currentColor"/>
        </svg>
        <span class="text">
            <span
                v-for="(part, index) in parts"
                :key="index"
                :class="{ 'strong': part.strong }"
            >{{ part.text }}</span>
        </span>
    </div>
</template>

<script>
import {mapState} from 'vuex';

const SUFFIX = ' 취급하는 약국에서 검색됩니다.';

export default {
    name: 'medicineFilterNotice',
    computed: {
        ...mapState(['pharmacyMedicineFilter']),
        isFiltered: function()
        {
            return this.pharmacyMedicineFilter.insulins.length > 0 || this.pharmacyMedicineFilter.baqsimi;
        },
        // 선택 상태에 따른 안내 문구 (강조할 부분은 strong)
        parts: function()
        {
            const insulins = this.pharmacyMedicineFilter.insulins;
            const baqsimi = this.pharmacyMedicineFilter.baqsimi;

            if(!this.isFiltered)
            {
                return [{ text: '취급 약품과 관계없이 검색됩니다.' }];
            }

            if(insulins.length === 0)
            {
                return [
                    { text: '바크시미', strong: true },
                    { text: '를' + SUFFIX }
                ];
            }

            // 1개면 약품명, 여러 개면 '인슐린'
            const insulin = insulins.length > 1 ? '인슐린' : insulins[0];

            if(!baqsimi)
            {
                return [
                    { text: '선택된 ' },
                    { text: insulin, strong: true },
                    { text: this.josa(insulin, '을', '를') + SUFFIX }
                ];
            }

            return [
                { text: '선택된 ' },
                { text: insulin, strong: true },
                { text: this.josa(insulin, '과', '와') + ' ' },
                { text: '바크시미', strong: true },
                { text: '를' + SUFFIX }
            ];
        }
    },
    methods: {
        // 마지막 글자 받침 유무로 조사 선택 (숫자로 끝나면 읽는 소리 기준)
        josa: function(word, withBatchim, withoutBatchim)
        {
            const last = word.charAt(word.length - 1);
            const code = last.charCodeAt(0);
            let hasBatchim = false;

            if(code >= 0xAC00 && code <= 0xD7A3)
            {
                hasBatchim = (code - 0xAC00) % 28 !== 0;
            }
            else if(/[0-9]/.test(last))
            {
                // 영, 일, 삼, 육, 칠, 팔 은 받침이 있다
                hasBatchim = '013678'.indexOf(last) > -1;
            }

            return hasBatchim ? withBatchim : withoutBatchim;
        }
    }
}
</script>

<style scoped>
    /* 선택 없음: 회색 / 선택 있음: 파란색 */
    .notice {
        width: 100%;
        display: flex;
        align-items: flex-start;
        margin-top: 12px;
        padding: 10px 12px;
        box-sizing: border-box;
        border-radius: 8px;
        background: var(--Gray-20, #F3F5F8);
        color: var(--Gray-60, #6B7684);
        transition: background-color 0.2s ease, color 0.2s ease;
    }
    .notice-active {
        background: #EAF1FB;
        color: #184FA1;
    }
    .icon {
        flex-shrink: 0;
        margin-top: 1px;
    }
    .text {
        margin-left: 6px;
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        word-break: keep-all;
        overflow-wrap: anywhere;
    }
    .notice-active .text {
        color: var(--Gray-100, #1E1E1E);
    }
    .strong {
        color: #184FA1;
        font-weight: 600;
    }
</style>



// WEBPACK FOOTER //
// src/components/molecules/maps/MedicineFilterNotice.vue